/**
 * The parent an Undo of a drive drag-and-drop move puts the item back under. A drag's payload carries no parent, so it
 * comes from the listing the item was dragged out of: `null` is the drive root; `undefined` (the item isn't in the
 * listing) records no whole-move undo — a split is still undone under its own root.
 */
export function dragMoveUndoParent(listing: ReadonlyArray<{ id: string; parentId?: string | null }>, fileId: string): string | null | undefined {
  const row = listing.find((f) => f.id === fileId)
  return row ? (row.parentId ?? null) : undefined
}
